<template>
  <div class="download-menu" v-click-outside="closeMenu">
    <button 
      class="download-button" :class="{ 'is-open': open }" @click="open = !open">
      <i class="fa fa-download"></i>
      <span>Download Data</span>
      <i class="fa fa-chevron-down" :class="{ 'is-open': open }"></i>
    </button>

    <div v-if="open" class="download-dropdown">
      <button
        v-for="option in options"
        :key="option.value"
        class="download-option"
        @click="select(option)"
      >
        <i :class="option.icon"></i>
        <span>{{ option.label }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    default: () => [
      { value: 'csv', label: 'Download as CSV', icon: 'fa fa-file-csv' },
      { value: 'pdf', label: 'Download as PDF', icon: 'fa fa-file-pdf' },
      { value: 'png', label: 'Download as Image', icon: 'fa fa-image' },
    ],
  },
})

const emit = defineEmits(['select'])

const open = ref(false)

function select(option) {
  emit('select', option.value)
  open.value = false
}

function closeMenu() {
  open.value = false
}
</script>

<style scoped>
.download-menu {
  position: relative;
  display: inline-block;
  font-size: 0.75rem;
}

.download-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.9rem;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.15s ease;
  font-family: var(--font-heading) !important;
}

.download-button:hover {
  background: #f6f8fa;
}

.download-dropdown {
  width: fit-content;
  min-width: 175px;
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 220px;
  background: white;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 8px;
  box-shadow:
    0 4px 12px rgba(0,0,0,0.08),
    0 1px 3px rgba(0,0,0,0.12);
  overflow: hidden;
  z-index: 1000;
}

.download-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.25rem 0.9rem;
  border: none;
  background: white;
  text-align: left;
  font-family: var(--font-heading) !important;
  cursor: pointer;
}

.download-option:hover {
  background: #f6f8fa;
}

.download-option + .download-option {
  border-top: 1px solid #eee;
}

/* first option */
.download-option:first-child {
  border-top: none;
  border-radius: 6px 6px 0 0;
  /* border-bottom: 1px solid var(--color-border); */
  border-bottom: 1px solid rgb(204, 204, 204);
}
.download-option:last-child {
  border-bottom: none;
  /* border-top: 1px solid var(--color-border); */
  border-top: 1px solid rgb(204, 204, 204);
  border-radius: 0 0 6px 6px;
}
</style>